<template>
	<div style="width: 100%;">
		<div>动画设置</div>
		<div v-for="(item,index) in animateConfig" :key="index">
			<!-- 
			<div style="color: #ff5500 ;margin-top: 10px;display: flex;justify-content: space-between;">
				<div>
					动画 {{index + 1}}
				</div>
				<div @click="animateConfig.splice(index,1)" style="cursor: pointer;color: #8c62ff;">删除</div>
			</div>
			<div style="margin-top: 6px;">y方向</div>
			<div>
				<div style="" v-for="(childItem,childIndex) in item.y" :key="childIndex">

					<div
						style="color: #ff5500 ;margin-top: 6px;margin-left: 6px;display: flex;justify-content: space-between;">
						<div>y方向片段 {{childIndex + 1}} </div>
						<div @click="item.y.splice(childIndex,1)" style="cursor: pointer;color: #8c62ff;">删除</div>
					</div>
					<div style="display: flex;align-items: center;flex-wrap: wrap;margin-left: 5px;">
						<div
							style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: calc(50% - 5px);margin-top: 10px;">
							<el-select size="mini" v-model="childItem.type" placeholder="从/到">
								<el-option label="从" value="from">
								</el-option>
								<el-option label="到" value="to">
								</el-option>
							</el-select>
							<div style="font-size: 12px;transform: scale(0.85);">起点/终点</div>
						</div>
						<div
							style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: calc(50% - 5px);margin-left: 5px;margin-top: 10px;">
							<el-input type="number" v-model="childItem.duration" size="mini"
								placeholder="单位/s"></el-input>
							<div style="font-size: 12px;transform: scale(0.85);">时间区间内执行</div>
						</div>
						<div
							style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: calc(50% - 5px);margin-top: 10px;">
							<el-input type="number" size="mini" v-model="childItem.delay" placeholder="单位/s"></el-input>
							<div style="font-size: 12px;transform: scale(0.85);">延迟播放时间</div>
						</div>

						<div
							style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: calc(50% - 5px);margin-left: 5px;margin-top: 10px;">
							<el-input type="number" size="mini" v-model="childItem.value" placeholder="像素"></el-input>
							<div style="font-size: 12px;transform: scale(0.85);">像素</div>
						</div>
					</div>

				</div>

				<div style="height: 10px;width: 100%;"></div>
				<div @click="addY(item)"
					style="padding: 4px 8px;background-color: black;color: #fff;border-radius: 6px;margin: auto;cursor: pointer;width: fit-content;">
					添加Y方向片段</div>
			</div>


			<div style="margin-top: 6px;">x方向</div>

			<div>
				<div style="" v-for="(childItem,childIndex) in item.x" :key="childIndex">
					<div
						style="color: #ff5500 ;margin-top: 6px;margin-left: 6px;display: flex;justify-content: space-between;">
						<div>x方向片段 {{childIndex + 1}} </div>
						<div style="cursor: pointer;color: #8c62ff;" @click="item.x.splice(childIndex,1)">删除</div>
					</div>
					<div style="display: flex;align-items: center;flex-wrap: wrap;margin-left: 5px;">
						<div
							style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: calc(50% - 5px);margin-top: 10px;">
							<el-select size="mini" v-model="childItem.type" placeholder="从/到">
								<el-option label="从" value="from">
								</el-option>
								<el-option label="到" value="to">
								</el-option>
							</el-select>
							<div style="font-size: 12px;transform: scale(0.85);">起点/终点</div>
						</div>
						<div
							style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: calc(50% - 5px);margin-left: 5px;margin-top: 10px;">
							<el-input type="number" v-model="childItem.duration" size="mini"
								placeholder="单位/s"></el-input>
							<div style="font-size: 12px;transform: scale(0.85);">时间区间内执行</div>
						</div>
						<div
							style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: calc(50% - 5px);margin-top: 10px;">
							<el-input type="number" size="mini" v-model="childItem.delay" placeholder="单位/s"></el-input>
							<div style="font-size: 12px;transform: scale(0.85);">延迟播放时间</div>
						</div>

						<div
							style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: calc(50% - 5px);margin-left: 5px;margin-top: 10px;">
							<el-input type="number" size="mini" v-model="childItem.value" placeholder="像素"></el-input>
							<div style="font-size: 12px;transform: scale(0.85);">像素</div>
						</div>
					</div>

				</div>

				<div style="height: 10px;width: 100%;"></div>
				<div @click="addX(item)"
					style="padding: 4px 8px;background-color: black;color: #fff;border-radius: 6px;margin: auto;cursor: pointer;width: fit-content;">
					添加X方向片段</div>
			</div>

			<div style="margin-top: 6px;">旋转</div>

			<div>
				<div style="" v-for="(childItem,childIndex) in item.rotate" :key="childIndex">
					<div
						style="color: #ff5500 ;margin-top: 6px;margin-left: 6px;display: flex;justify-content: space-between;">
						<div>旋转片段 {{childIndex + 1}} </div>
						<div style="cursor: pointer;color: #8c62ff;" @click="item.rotate.splice(childIndex,1)">删除</div>
					</div>
					<div style="display: flex;align-items: center;flex-wrap: wrap;margin-left: 5px;">
						<div
							style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: calc(50% - 5px);margin-top: 10px;">
							<el-select size="mini" v-model="childItem.type" placeholder="从/到">
								<el-option label="从" value="from">
								</el-option>
								<el-option label="到" value="to">
								</el-option>
							</el-select>
							<div style="font-size: 12px;transform: scale(0.85);">起点/终点</div>
						</div>
						<div
							style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: calc(50% - 5px);margin-left: 5px;margin-top: 10px;">
							<el-input type="number" v-model="childItem.duration" size="mini"
								placeholder="单位/s"></el-input>
							<div style="font-size: 12px;transform: scale(0.85);">时间区间内执行</div>
						</div>
						<div
							style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: calc(50% - 5px);margin-top: 10px;">
							<el-input type="number" size="mini" v-model="childItem.delay" placeholder="单位/s"></el-input>
							<div style="font-size: 12px;transform: scale(0.85);">延迟播放时间</div>
						</div>

						<div
							style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: calc(50% - 5px);margin-left: 5px;margin-top: 10px;">
							<el-input type="number" size="mini" v-model="childItem.value" placeholder="像素"></el-input>
							<div style="font-size: 12px;transform: scale(0.85);">像素</div>
						</div>
					</div>

				</div>

				<div style="height: 10px;width: 100%;"></div>
				<div @click="addRotate(item)"
					style="padding: 4px 11px;background-color: black;color: #fff;border-radius: 6px;margin: auto;cursor: pointer;width: fit-content;">
					添加旋转片段</div>
			</div>

			<div style="margin-top: 10px;">缩放</div>

			<div>
				<div style="" v-for="(childItem,childIndex) in item.scale" :key="childIndex">
					<div
						style="color: #ff5500 ;margin-top: 6px;margin-left: 6px;display: flex;justify-content: space-between;">
						<div>缩放片段 {{childIndex + 1}} </div>
						<div style="cursor: pointer;color: #8c62ff;" @click="item.scale.splice(childIndex,1)">删除</div>
					</div>
					<div style="display: flex;align-items: center;flex-wrap: wrap;margin-left: 5px;">
						<div
							style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: calc(50% - 5px);margin-top: 10px;">
							<el-select size="mini" v-model="childItem.type" placeholder="从/到">
								<el-option label="从" value="from">
								</el-option>
								<el-option label="到" value="to">
								</el-option>
							</el-select>
							<div style="font-size: 12px;transform: scale(0.85);">起点/终点</div>
						</div>
						<div
							style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: calc(50% - 5px);margin-left: 5px;margin-top: 10px;">
							<el-input type="number" v-model="childItem.duration" size="mini"
								placeholder="单位/s"></el-input>
							<div style="font-size: 12px;transform: scale(0.85);">时间区间内执行</div>
						</div>
						<div
							style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: calc(50% - 5px);margin-top: 10px;">
							<el-input type="number" size="mini" v-model="childItem.delay" placeholder="单位/s"></el-input>
							<div style="font-size: 12px;transform: scale(0.85);">延迟播放时间</div>
						</div>

						<div
							style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: calc(50% - 5px);margin-left: 5px;margin-top: 10px;">
							<el-input type="number" size="mini" v-model="childItem.value" placeholder="像素"></el-input>
							<div style="font-size: 12px;transform: scale(0.85);">像素</div>
						</div>
					</div>

				</div>

				<div style="height: 10px;width: 100%;"></div>
				<div @click="addScale(item)"
					style="padding: 4px 11px;background-color: black;color: #fff;border-radius: 6px;margin: auto;cursor: pointer;width: fit-content;">
					添加缩放片段</div>
			</div>

			<div style="margin-top: 10px;">透明度</div>

			<div>
				<div style="" v-for="(childItem,childIndex) in item.opacity" :key="childIndex">
					<div
						style="color: #ff5500 ;margin-top: 6px;margin-left: 6px;display: flex;justify-content: space-between;">
						<div>透明度片段 {{childIndex + 1}} </div>
						<div style="cursor: pointer;color: #8c62ff;" @click="item.opacity.splice(childIndex,1)">删除</div>
					</div>
					<div style="display: flex;align-items: center;flex-wrap: wrap;margin-left: 5px;">
						<div
							style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: calc(50% - 5px);margin-top: 10px;">
							<el-select size="mini" v-model="childItem.type" placeholder="从/到">
								<el-option label="从" value="from">
								</el-option>
								<el-option label="到" value="to">
								</el-option>
							</el-select>
							<div style="font-size: 12px;transform: scale(0.85);">起点/终点</div>
						</div>
						<div
							style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: calc(50% - 5px);margin-left: 5px;margin-top: 10px;">
							<el-input type="number" v-model="childItem.duration" size="mini"
								placeholder="单位/s"></el-input>
							<div style="font-size: 12px;transform: scale(0.85);">时间区间内执行</div>
						</div>
						<div
							style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: calc(50% - 5px);margin-top: 10px;">
							<el-input type="number" size="mini" v-model="childItem.delay" placeholder="单位/s"></el-input>
							<div style="font-size: 12px;transform: scale(0.85);">延迟播放时间</div>
						</div>

						<div
							style="display: flex;flex-direction: column;align-items: center;justify-content: center;width: calc(50% - 5px);margin-left: 5px;margin-top: 10px;">
							<el-input type="number" size="mini" v-model="childItem.value" placeholder="像素"></el-input>
							<div style="font-size: 12px;transform: scale(0.85);">像素</div>
						</div>
					</div>

				</div>

				<div style="height: 10px;width: 100%;"></div>
				<div @click="addOpacity(item)"
					style="padding: 4px 6px;background-color: black;color: #fff;border-radius: 6px;margin: auto;cursor: pointer;width: fit-content;">
					添加透明度片段</div>
			</div> -->



			<div style="display: flex;justify-content: space-between;margin-top: 10px;align-items: center;">
				<div style="width: 80px;">
					动画类型
				</div>
				<el-select style="margin-left: 10px;" size="mini" v-model="item.type">
					<el-option v-for="(typeItem,typeIndex) in typeOption" :key="typeIndex" :label="typeItem.label"
						:value="typeItem.value">
					</el-option>
				</el-select>
			</div>

			<div>
				<div style="margin-top: 10px;">
					{{getTit(item)}}
				</div>
				<div style="margin-left: 10px;margin-top: 10px;">
					<div>
						<el-input type="number" size="mini" v-model="item.value"></el-input>
					</div>
				</div>
			</div>



			<div style="display: flex;justify-content: space-between;margin-top: 10px;align-items: center;">
				<div style="width: 80px;">
					动效类型
				</div>
				<el-select style="margin-left: 10px;" size="mini" v-model="item.ease">
					<el-option v-for="(easeItem,easeIndex) in easeOption" :key="easeIndex" :label="easeItem.label"
						:value="easeItem.value">
					</el-option>
				</el-select>
			</div>

			<div style="display: flex;justify-content: space-between;align-items: center;margin-top: 10px;">
				<div style="width: 80px;">
					动画速度
				</div>
				<div style="margin-left: 10px;">
					<div>
						<el-input type="number" size="mini" v-model="item.playbackRate" placeholder="单位/s"></el-input>
					</div>
				</div>
			</div>

			<div style="display: flex;justify-content: space-between;margin-top: 10px;align-items: center;">
				<div style="width: 80px;">
					循环播放
				</div>
				<div style="margin-left: 10px;">
					<el-select size="mini" v-model="item.loop" placeholder="请选择">
						<el-option label="是" :value="true">
						</el-option>
						<el-option label="否" :value="false">
						</el-option>
					</el-select>
				</div>
			</div>

			<div style="display: flex;justify-content: space-between;margin-top: 10px;align-items: center;">
				<div style="width: 100px;">
					动画时间/s
				</div>
				<div style="margin-left: 10px;">
					<el-input type="number" size="mini" v-model="item.duration" placeholder="单位/s"></el-input>
				</div>
			</div>
			<div style="display: flex;justify-content: space-between;align-items: center;margin-top: 10px;">
				<div style="width: 100px;">
					延迟播放/s
				</div>
				<div style="margin-left: 10px;">
					<div>
						<el-input type="number" size="mini" v-model="item.delay" placeholder="单位/s"></el-input>
					</div>
				</div>
			</div>



			<!-- <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 10px;">
				<div style="width: 80px;">
					循环延迟
				</div>
				<div style="margin-left: 10px;">
					<div>
						<el-input type="number" size="mini" v-model="item.loopDelay" placeholder="单位/s"></el-input>
					</div>
				</div>
			</div> -->

			<!-- 	<div style="display: flex;justify-content: space-between;margin-top: 10px;">
				<div>
					可回溯
				</div>
				<div style="width: 100px;margin-right: 10px;">
					<el-select size="mini" v-model="item.reversed" placeholder="请选择">
						<el-option label="是" :value="true">
						</el-option>
						<el-option label="否" :value="false">
						</el-option>
					</el-select>
				</div>
			</div> -->

			<!-- <div style="display: flex;justify-content: space-between;margin-top: 10px;">
				<div>
					可见时播放
				</div>
				<div style="width: 100px;margin-right: 10px;">
					<el-select size="mini" v-model="item.lookedPlay" placeholder="请选择">
						<el-option label="是" :value="true">
						</el-option>
						<el-option label="否" :value="false">
						</el-option>
					</el-select>
				</div>
			</div> -->
		</div>


		<!-- <div style="display: flex;align-items: center;justify-content: center;margin-top: 10px;width: 100%;">
			<div @click="addAnimate"
				style="padding: 4px 6px;background-color: black;color: #fff;border-radius: 6px;cursor: pointer;width: fit-content;margin: auto;">
				添加动画</div>
		</div> -->
	</div>
</template>

<script>
	import {
		data
	} from 'jquery'
	import {
		method
	} from 'lodash'

	export default {
		props: {
			animateConfig: {
				type: Array,
				default: () => {
					return []
				}
			},
			equipment: {
				type: String,
				default: "pc"
			},
		},
		data() {
			return {
				typeOption: [{
						value: "topBto",
						label: "上" //改成上
					},
					{
						value: "leftRight",
						label: "左" //改成左
					},

					{
						value: "bto",
						label: "下"
					},
					{
						value: "right",
						label: "右"
					},

					{
						value: "scale",
						label: "放大" // 改成放大
					},
					
					{
						value: "scaleSmall",
						label: "缩小"
					},
					
					{
						value: "rotate",
						label: "旋转"
					},
					{
						value: "opacity",
						label: "透明"
					},
				],
				easeOption: [{
						value: "linear",
						label: "线性"
					},
					{
						value: "outBack",
						label: "回弹"
					},
					{
						value: "inOutElastic",
						label: "振幅"
					},
					
				],
				dialogVisible: false
			}
		},
		methods: {
			getTit(item) {
				if (item.type == 'topBto') {
					return '从上多少px至原位'
				}
				if (item.type == 'leftRight') {
					return '从左多少px至原位'
				}
				
				if (item.type == 'bto') {
					return '从下多少px至原位'
				}
				if (item.type == 'right') {
					return '从右多少px至原位'
				}
				
				
				if (item.type == 'scale') {
					return '放大至原来多少倍'
				}
				
				
				if (item.type == 'scaleSmall') {
					return '缩小至原来多少倍'
				}
				
				if (item.type == 'rotate') {
					return '旋转多少度 0 - 360'
				}
				if (item.type == 'opacity') {
					return '透明度多少 0 - 1'
				}
			},
			handleClose() {

			},
			addOpacity(item) {
				item.opacity.push({
					type: 'from',
					duration: '',
					delay: 0,
					value: 0
				})
			},
			addScale(item) {
				item.scale.push({
					type: 'from',
					duration: '',
					delay: 0,
					value: 0
				})
			},
			addRotate(item) {
				item.rotate.push({
					type: 'from',
					duration: '',
					delay: 0,
					value: 0
				})
			},
			addX(item) {
				item.x.push({
					type: 'from',
					duration: '',
					delay: 0,
					value: 0
				})
			},
			addY(item) {
				item.y.push({
					type: 'from',
					duration: '',
					delay: 0,
					value: 0
				})
			},
			addAnimate() {
				this.animateConfig.push({
					// y
					y: [],
					// x
					x: [],
					//旋转
					rotate: [],
					// 透明度
					opacity: [],
					// 缩放
					scale: [],
					// 可见时播放
					lookedPlay: true,
					// 动效类型
					ease: "linear",
					// 	// 循环播放
					loop: false,
					// 	// 循环延迟
					loopDelay: 0,
					// 	// 播放时间 默认2s
					duration: 2,
					// 	// 延迟多久播放
					delay: 0,
					// 	// 播放速度
					playbackRate: 1,
					// 回溯
					// reversed: true,
				})
			}
		}

	}
</script>

<style>
</style>